
// notes
export const GET_NOTES = "/notes";
export const ADD_NEW_NOTE = "/notes";
export const UPDATE_NOTE = "/notes";
export const DELETE_NOTE = "/notes";


